import { useFormContext } from "react-hook-form"
import { ErrorMessage as HookFormErrorMessage } from "@hookform/error-message"

const DEFAULT_REQUIRED_ERROR_MESSAGE = "Obligatoriskt fält"

export function ErrorMessage(props) {
  const {
    formState: { errors }
  } = useFormContext()

  return (
    <HookFormErrorMessage
      {...props}
      errors={errors}
      render={({ message }) => (
        <span className="mt-1 text-xs text-red-100">
          {message || DEFAULT_REQUIRED_ERROR_MESSAGE}
        </span>
      )}
    />
  )
}

export const HTMLError = ({ message }) => {
  return (
    <div
      className="mt-2 text-sm text-red-100 wysiwyg-content"
      dangerouslySetInnerHTML={{ __html: message }}
    />
  )
}
